import { isDemoEnvironment } from "../../services/environment";

const DemoNote = ({ text = "(RD-1238) Default text" }) => {
  if (!isDemoEnvironment()) {
    return null;
  }
  return (
    <div className="flex flex-row text-left items-center  gap-4 border border-color-border-primary text-color-dark-text-tertiary rounded-lg p-4 text-sm max-w-md">
      <i className="fas fa-circle-info text-color-warning-primary text-lg" />
      <div>{text}</div>
    </div>
  );
};

export default DemoNote;
